<template>
  <div class="login-form">
    <form @submit="onSubmit" >
      <div class="input-form">
        <div class="email-input-group">
          <p class="input-label">Email</p>
          <input class="input" v-model="form.email" required />
          <p class="invalid-label" v-show="hasInvalidEmail"><img src="@/assets/error.png" />Email invalid</p>
        </div>

        <div class="password-input-group">
          <p class="input-label">Password</p>
          <input class="input" v-model="form.password" type="password" required />
          <p class="invalid-label" v-show="hasInvalidPassword"><img src="@/assets/error.png" />Password invalid</p>
        </div>
      </div>

      <b-button class="form-button" type="submit" variant="primary" id="login-button">Login</b-button>
      <div>
        <p id="forgot-password-button" @click.prevent="onForgotPassword">Forgotten password?</p>
        <p id="register-text">New to Cast? <u id="register-button" @click.prevent="onRegister">Sign up</u></p>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data(){
    return {
      form: {
        email: '',
        password: ''
      },
      hasInvalidEmail: false,
      hasInvalidPassword: false,
    }
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault()
      var response_json = await this.getAuthToken()
      if (response_json.status === "fail") {
        this.hasInvalidEmail = true
        this.hasInvalidPassword = true
      } else {
        var accessToken = response_json.access_token
        this.$emit('logged-in', this.form.email, accessToken)
        this.form.email = ''
        this.form.password = ''
        this.hasInvalidEmail = false
        this.hasInvalidPassword = false
      }
    },
    onForgotPassword() {
      this.form= {
        email: '',
        password: ''
      },
      this.hasInvalidEmail = false,
      this.hasInvalidPassword = false,
      this.$emit('show-view', 2)
    },
    onRegister() {
      this.form= {
        email: '',
        password: ''
      },
      this.hasInvalidEmail = false,
      this.hasInvalidPassword = false,
      this.$emit('show-view', 1)
    },
    async getAuthToken() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      var urlencoded = new URLSearchParams();
      urlencoded.append("grant_type", "password");
      urlencoded.append("client_id", "CAST");
      urlencoded.append("username", this.form.email);
      urlencoded.append("password", this.form.password);
      urlencoded.append("device_id", "CAST");

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      
      return await fetch(`https://${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : 'stage-'}auth.incrowdsports.com/oauth/token`, requestOptions)
        .then(response => response.json())
        .then(data => {
          return data
        })
        .catch(error => console.log('error', error));
    },
  }
}

</script>